import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    if (!isValidPhoneNumber(value)) {
      return { invalidPhone: true };
    }

    return null;
  };
}

/**
 * Parses a phone number string and returns E.164 format.
 * Returns an empty string if the input is empty or unparseable.
 */
export function toE164(phone: string): string {
  if (!phone) return '';

  try {
    return parsePhoneNumber(phone).format('E.164');
  } catch {
    return '';
  }
}

/**
 * Formats a phone number for display in international format.
 * Returns the raw input if parsing fails.
 */
export function formatPhoneNumber(phone: string): string {
  try {
    return parsePhoneNumber(phone).formatInternational();
  } catch {
    return phone;
  }
}
